/* import __COLOCATED_TEMPLATE__ from './series-completion-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();